import { schema } from 'normalizr';

export const rateType = new schema.Entity('rateTypes');
export const rateTypes = [rateType];

rateType.define({
  schedule: require('shared/store/modules/schedules/schemas').schedule,
  schedules: require('shared/store/modules/schedules/schemas').schedules
});
